export const localizeNumber = (number: number | string) => {
  if (typeof number === 'string') {
    number = Number(number);
  }

  try {
    return number.toLocaleString();
  } catch (error) {
    return '-';
  }
};

const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });
const suffixes = { one: 'st', two: 'nd', few: 'rd', other: 'th' };
export const ordinalize = (n: number): string => `${n}${suffixes[ordinalRules.select(n)]}`;

export function hexToRgb(hex: string) {
  const parsedRGB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!parsedRGB) {
    return null;
  }

  return `${parseInt(parsedRGB[1], 16)}, ${parseInt(parsedRGB[2], 16)}, ${parseInt(
    parsedRGB[3],
    16,
  )}`;
}
